import {PlayerLeftAction} from 'src/Action';
import {pointerRenderer} from 'src/Pixi/PointerRenderer';
import HudRenderer from 'src/Pixi/HudRenderer';
import {Game} from '../Game';

export class PlayerLeft {
    public constructor(public game: Game) {
        // Sets instance variables
    }

    public byServer({index}: PlayerLeftAction): void {
        const player = this.game.players[index];
        player.isAlive = false;
        this.game.hasLeft.add(index);
        pointerRenderer.hidePointer(index);
        HudRenderer.killPlayer(player);
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/PlayerLeft.ts